import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getEfillingSummaryReport } from '../../../redux/actions/eFilling'
import AnnualTaxRemittanceWidget from '../../../widgets/eFillingListFormWidgets/AnnualTaxRemittanceWidget'
import CheckApprovalWidget from '../../../widgets/admin/manage/CheckApprovalWidget'
import { getCheckApproverList } from '../../../redux/actions/approveProject'

export default function CheckApproval() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')
  const pageNumber = 1
  const pageSize = 10

  useEffect(() => {
    handleGetSchema()
  }, [])

  const GetBudgetYear = () => {
    var defaultYear = new Date().getFullYear() + 543
    if (new Date().getMonth() >= 9) {
      defaultYear = new Date().getFullYear() + 543 + 1 //ปีงบประมาณ = ปีปัจุบัน+1 (เดือน 10 11 12)
    }
    return defaultYear
  }

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      var year = GetBudgetYear()
      const request = {
        projectCode: '',
        projectName: '',
        approveStatus: 0,
        approveType: 0,
        approverName: '',
        budgetYear: year,
      }
      const response = await getCheckApproverList(pageSize, pageNumber, request)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSearch>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSearch>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isSearch>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <CheckApprovalWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}
